<template>
  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h2 class="text-xl font-bold mb-4 text-gray-800">Item Details</h2>
      <!-- Image Preview -->
      <div v-if="item.filename" class="mt-4">
        <img :src="item.filename" alt="Item Image" class="mt-2 w-full h-auto rounded-lg"/>
      </div>
      <div v-else class="mt-4 text-gray-500">
        <p>No image available for this item.</p>
      </div>
      <p><strong>Item Name:</strong> {{ item.name }}</p>
      <p><strong>Description:</strong> {{ item.description }}</p>
      <p><strong>Price :</strong> {{ item.price }}</p>
      <p><strong>Quantity :</strong> {{ item.quantity }}</p>
      <p><strong>Category :</strong> {{ item?.category?.name }}</p>
      <p><strong>Unit:</strong> {{ item.unit }}</p>
      <button @click="closeModal" class="mt-4 w-full text-gray-600">Close</button>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
        item: {
        },
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
  };
  </script>
  